import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import DetailSlider from "../../organisms/slider/DetailSlider";

import VenorForm from "../../organisms/venorForm";
import VendorBookNowModal from "../../organisms/modals/VendorBookModal";
import useGet from "../../customHooks/useGet/UseGet";

const VendorDetail = () => {
  const [isBookModalShow, setIsBookModalShow] = useState(false);
  const location = useLocation();
  const { pathname } = location;
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const { name } = useParams();
  const { data } = useGet(`list_vendor?`);
  const Item = data?.vendors?.find((item) => item.id == id);
  console.log("Item", Item);

  const handleBookModalChange = () => setIsBookModalShow(!isBookModalShow);
  return (
    <>
      {<VendorBookNowModal isBookModalShow={true} />}
      <div className="my-4 px-5">
        <h2>{name} </h2>
      </div>

      <div className=" px-5 d-flex py-2">
        <span>Website</span>
        <span className="pl-4">Phone Number</span>
      </div>
      <div className="my-4 px-5">
        <div className="row">
          <div className="col-md-8 col-sm-12 ">
            <div className="detail_slider">
              {Item?.paid === 1 ? (
                <span class="badge bg-secondary featured px-2 py-1">
                  featured
                </span>
              ) : null}

              <img src={Item?.media[0].image} alt="" />
            </div>
          </div>
          <div className="col-md-4 d-none d-lg-block">
            <div className="card p-4">
              <VenorForm />
            </div>
          </div>
          <div className="mt-3">
            <h5>Categories</h5>
            <ul>
              <li>{Item?.category?.name}</li>
            </ul>
            <h5>Social Media</h5>
            <div className="d-flex mt-3">
              <i class="fa-xl fas fa-globe"></i>
              <i class="fa-xl fab fa-facebook mx-3"></i>
              <i class="fa-xl fab fa-instagram-square"></i>
            </div>
          </div>
        </div>
        <div className="d-sm-block d-md-block d-lg-none fixed-bottom card p-2">
          <div className="w-100 m-auto d-flex justify-content-center">
            <div>
              <button
                type="button"
                className="btn text-white bg-book-now"
                onClick={handleBookModalChange}
                data-toggle="modal"
                data-target="#BookNowModalBox"
              >
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorDetail;
